<template>
  <div id="app" :class="isMini ? 'in-wx' : 'in-cdn'">
      <keep-alive :include="['Home', 'DailyReport']">
        <router-view></router-view>
      </keep-alive>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus'
import { getQueryString, isInTH } from '@/utils'
import { outerConfig, pageConfig } from '@/config/pageConfig'

export default {
  data () {
    return {
      isWx: process.env.RUNTIME === 'wx'
    }
  },
  computed: {
    isMini () {
      return this.$browserEnv === 'mini'
    }
  },
  mounted () {
    // 异步拉取 pageConfig ，可以通过 this.pageConfig | this.globalConfig 来访问，可以使用 await this.pageConfig._remote 的方法来等待远程配置加载
    this.fetchPageConfig()
    // fix iOS下:active不生效的问题
    document.body.addEventListener('touchstart', function () {}, false)

    // 监听 wx 小程序页面回调
    const callback = () => {
      WeixinJSBridge.on('onPageStateChange', function (res) {
        EventBus.$emit('pageShow')
      })
    }
    if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
      callback()
    } else {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', callback, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', callback)
        document.attachEvent('onWeixinJSBridgeReady', callback)
      }
    }
  },
  methods: {
    async fetchPageConfig () {
      window.Vue.prototype.pageConfig = pageConfig
      window.Vue.prototype.globalConfig = pageConfig // 兼容历史遗留问题
      console.log("### origin pageConfig : ",this.pageConfig)
      await outerConfig()
      console.log("### remote pageConfig : ",this.pageConfig)
    }
  }
}
</script>

<style>
@import "~styles/lib/weui-v2.1.4.min.css";
</style>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &.in-cdn {
      .gudie-mask {
          .arrow {
              right: 15px;
          }
      }
  }
}
input, textarea {
  border: none;
  -moz-appearance:none;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance : none ;/*解决ios上按钮的圆角问题*/
  border-radius: 0;/*解决ios上输入框圆角问题*/
  outline:medium;/*去掉鼠标点击的默认黄色边框*/
  background-color: transparent;
}
.not-allow {
  opacity: .5;
}
// 修改默认颜色
.district-picker {
  .weui-btn_primary {
    background: #5675F1;
    &:active {
      background: #5675F1;
      opacity: .6;
    }
  }
}
</style>
